'use client';

import { c as _c } from "react/compiler-runtime";
import { ChangeMentoringConfirmAlert } from './_components/ChangeMentoringConfirmAlert';
import { ChangeOutcomeSummary } from './_components/ChangeOutcomeSummary';
import { DropDiscountConfirmAlert } from './_components/DropDiscountConfirmAlert';
import { IssuedOfferLink } from './_components/IssuedOfferLink';
import { RefusalAlert } from './_components/RefusalAlert';
import type { FormFeedbackModel } from './form-feedback-model';
type FormFeedbackProps = {
  model: FormFeedbackModel;
};
export function FormFeedback(t0) {
  const $ = _c(23);
  const {
    model
  } = t0;
  const {
    refusal,
    shownOutcome,
    shownOffer,
    dropDiscount,
    changeConfirm
  } = model;
  let t1;
  if ($[0] !== refusal) {
    t1 = refusal === null ? null : <RefusalAlert message={refusal} />;
    $[0] = refusal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== shownOutcome) {
    t2 = shownOutcome !== null ? <ChangeOutcomeSummary outcome={shownOutcome} /> : null;
    $[2] = shownOutcome;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== shownOffer) {
    t3 = shownOffer ? <IssuedOfferLink offerUrl={shownOffer.offerUrl} variant={shownOffer.variant} /> : null;
    $[4] = shownOffer;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = dropDiscount.pendingOffer !== null;
  let t5;
  let t6;
  if ($[6] !== dropDiscount) {
    t5 = () => dropDiscount.setPendingOffer(null);
    t6 = () => {
      if (dropDiscount.pendingOffer !== null) {
        dropDiscount.submitOffer(dropDiscount.pendingOffer.values);
      }
    };
    $[6] = dropDiscount;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  const t7 = dropDiscount.summary ?? "";
  let t8;
  if ($[9] !== dropDiscount.isPending || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <DropDiscountConfirmAlert isOpen={t4} onClose={t5} onConfirm={t6} isPending={dropDiscount.isPending} discountSummary={t7} />;
    $[9] = dropDiscount.isPending;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== changeConfirm) {
    t9 = changeConfirm.isChangeMode && changeConfirm.current !== null ? <ChangeMentoringConfirmAlert isOpen={changeConfirm.isOpen} onClose={() => changeConfirm.setIsOpen(false)} onConfirm={changeConfirm.onConfirm} isPending={changeConfirm.isPending} studentName={changeConfirm.current.studentName} currentTermsSummary={changeConfirm.termsInForceSummary ?? ""} newTermsSummary={changeConfirm.chosenTermsSummary} newPriceZloty={changeConfirm.renewalPriceZloty} discountSummary={changeConfirm.discountSummary} renewsAt={changeConfirm.current.renewsAt} mode={changeConfirm.mode} /> : null;
    $[15] = changeConfirm;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t8 || $[21] !== t9) {
    t10 = <>{t1}{t2}{t3}{t8}{t9}</>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}